//@ts-check
/**
 * Whether the capture sheet is open, and what it opens with.
 *
 * The sheet lives in the signed-in layout so it is reachable from every screen, but it is opened
 * from several places — the + button, a share arriving from another app, and the first run's
 * _Take a photo_. A tiny store beats threading callbacks through the layout for that.
 */

/**
 * @type {{
 *   open: boolean,
 *   prefill: string,
 *   photo: import("$lib/photos.svelte.js").PreparedPhoto | null,
 *   cameraMs: number,
 * }}
 */
export const capture = $state({
  open: false,
  prefill: "",
  photo: null,
  cameraMs: 0,
});

/**
 * Open the sheet, optionally with text already in the box, or a photo already taken.
 *
 * A photo is taken before the sheet opens, not after: iOS opens the camera only for a tap on the
 * file input itself, so a control that means "take a photo" has to be that input, and hand the
 * photo over. The sheet owns it from then on.
 *
 * @param {string} [prefill] e.g. the title and URL handed over by a share
 * @param {{ photo?: import("$lib/photos.svelte.js").PreparedPhoto, cameraMs?: number }} [taken]
 */
export function openCapture(prefill = "", { photo, cameraMs = 0 } = {}) {
  capture.prefill = prefill;
  capture.photo = photo ?? null;
  capture.cameraMs = cameraMs;
  capture.open = true;
}

export function closeCapture() {
  capture.open = false;
  capture.prefill = "";
  capture.photo = null;
  capture.cameraMs = 0;
}
